// import React from 'react';
import React, { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';
import aboutbannerx10 from "../assets/img/aboutbannerX10.png";
import { Link } from 'react-router-dom';
import year_title_bg from '../assets/img/update_2/bg/year_title_bg.svg'
import year_title_bg51 from '../assets/img/update_2/bg/year_title_bg51.svg'
import bgbanner2 from '../assets/img/update_2/bg/bannerbg2.png'
import mapx1 from "../assets/img/mapx1.jpg";
import mapx444 from "../assets/img/mapx444.jpg";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import about_6_1 from "../assets/img/update_2/normal/about_6_1.png";
import dishround from "../assets/img/update_2/normal/dishround.png";
import roundpotato from "../assets/img/update_2/normal/roundedpotato.png";
import contractfarm01 from "../assets/img/update_2/icon/contractfarm01.jpg";
import farmicon1 from "../assets/img/update_2/icon/farmicon1.svg";
import farm111 from "../assets/img/update_2/icon/farm111.jpg";
import farming222 from "../assets/img/update_2/icon/farming222.jpg";
import consistent01 from "../assets/img/update_2/icon/consistent01.jpg";
import consistenet111 from "../assets/img/update_2/icon/consistenet111.jpg";
import consistent222 from "../assets/img/update_2/icon/consistent222.jpg";
import quick01 from "../assets/img/update_2/icon/quick01.jpg";
import quick111 from "../assets/img/update_2/icon/quick111.jpg";
import quick222 from "../assets/img/update_2/icon/quick222.jpg";
import longshelf01 from "../assets/img/update_2/icon/longshelf01.jpg";
import longshelf111 from "../assets/img/update_2/icon/longshlef111.jpg";
import longshelf222 from "../assets/img/update_2/icon/longshelf222.jpg";
import tiger01 from "../assets/img/update_2/icon/tiger01.jpg";
import proudlymade111 from "../assets/img/update_2/icon/proudlymade111.jpg";
import tiger222 from "../assets/img/update_2/icon/tiger222.jpg";
import flexibility01 from "../assets/img/update_2/icon/flexibility01.jpg";
import flexibility111 from "../assets/img/update_2/icon/fexibility111.jpg";
import flexibility222 from "../assets/img/update_2/icon/flexibility222.jpg";
import testicardimg from "../assets/img/update_2/normal/testi-card_img.png";
import qualitydrivenupdated1 from "../assets/img/update_2/normal/qualitydrivenupdated1.jpg";
import mission1 from "../assets/img/update_2/normal/mission1.png";
import vision1 from "../assets/img/update_2/normal/vision1.png";
import customerfocuedupdated1 from "../assets/img/update_2/normal/customerfocusedupdated1.jpg";
import td11 from "../assets/img/update_2/normal/td11.jpg";
import backwardintegration1 from "../assets/img/update_2/normal/backwardintegration1.png";
import backint from "../assets/img/update_2/normal/backint.png";
import bgfriesupdated from "../assets/img/update_2/normal/bgfriesupdated.jpg";

import shrimpovingimgx1 from "../assets/img/update_2/normal/shrimpmovingimgx1.png";
import potatosmovingimgx1 from "../assets/img/update_2/normal/potatomovingimgx1.png";

import Footer from './footer';


const Termsandcondition = () => {
    const location = useLocation();

    useEffect(() => {
        const { hash } = location;
        if (hash) {
            const id = hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location]);




    return (


        <div>
       
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>


                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "25px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ color: 'white', margin: 0, padding: 0 ,fontFamily: 'helvetica', color: 'white'}}>TERMS AND CONDITION</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily: 'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily: 'helvetica', color: '#F0B323' }}>Terms and Condition</span></span>
                                    </li>
                                </ul>

                            </div>

                        </div>
                        <img
                            width="2000"
                            height="435"
                            src={aboutbannerx10}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',

                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />

                    </div>



                </div>
            </div>

            <br />

            <div className="container">
                <p>Welcome to <b>Icedream Global</b>. These Terms and Conditions govern your use of our website and services. By accessing or using our platform, you agree to comply with and be bound by the following terms.</p>

                <h5>1. Acceptance of Terms</h5>
                <p>By using our services, you confirm that you are at least 18 years of age and legally capable of entering into contracts. Continued use of our website and services constitutes acceptance of these terms.</p>

                <h5>2. Description of Services</h5>
                <p>Icedream Global is a trusted global exporter of premium frozen foods, specializing in processed snacks and ready-to-eat frozen meals. From production to international delivery, we ensure products meet strict standards of quality, taste, and freshness.</p>

                <h5>3. User Responsibilities</h5>
                <ul>
                    <li>Provide accurate and complete information when engaging with Icedream Global.</li>
                    <li>Use our website and services only for lawful purposes.</li>
                    <li>Refrain from misusing or interfering with the functionality of our website, systems, or content.</li>
                </ul> 

                <h5>4. Intellectual Property</h5>
                <p>All content, features, trademarks, graphics, and packaging designs associated with Icedream Global are the intellectual property of Icedream Global and may not be copied, reproduced, or reused without prior written consent.</p>

                <h5>5. Payment Terms</h5>
                <p>For business transactions, all payments must be made in accordance with the pricing, billing terms, and agreements provided at the time of order confirmation. Unless otherwise stated, all payments are non-refundable.</p>


                <h5>6. Product Quality & Liability</h5>
                <p>While Icedream Global ensures that every product meets the highest safety and quality standards, we are not liable for indirect, incidental, or consequential damages arising from improper storage, handling, or misuse of products after delivery.</p>

                <h5>7. International Shipping & Compliance</h5>
                <p>All shipments are subject to applicable export/import regulations. Customers are responsible for ensuring compliance with their country’s food safety and import policies.</p>

                <h5>8. Termination of Services</h5>
                <p>We reserve the right to suspend or terminate access to our services if these Terms are violated or if the platform is misused in a harmful or unlawful way.</p>

                <h5>9. Changes to Terms</h5>
                <p>Icedream Global reserves the right to update or change these Terms at any time without prior notice. We recommend reviewing this page periodically. Continued use of the service after changes implies acceptance.</p>   

                <h5>10. Governing Law</h5>
                <p>These Terms shall be governed by and interpreted in accordance with the laws of India, without regard to conflict of law provisions.</p>  

                <h5>11. Contact Us</h5>
                <p>For questions regarding these Terms and Conditions, please contact us at: <br/>
                    <b>Email:</b> support@icedreamglobal.com</p>                                                                                                                                                                           

                    
            </div>
            <br />
            <br />

        
          
            <Footer />

        </div>
    );
};

export default Termsandcondition;
